var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.attachments.length ? _c('v-sheet', [_c('h5', {
    staticClass: "page-text page-text--lg mb-8 mb-lg-16"
  }, [_vm._v("첨부파일")]), _c('p', {
    staticClass: "page-text line-height-15"
  }, [_c('v-chip-group', [_vm._l(_vm.attachments, function (item) {
    return [_c('v-chip', {
      key: item._id,
      attrs: {
        "href": item.url,
        "download": "",
        "large": "",
        "label": "",
        "outlined": ""
      }
    }, [_c('v-icon', {
      staticClass: "mr-4 ml-n2",
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-file-outline")]), _vm._v(" " + _vm._s(item.name) + " ")], 1)];
  })], 2)], 1)]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }